import RequestError from './RequestError.js';

class Request {
    static create(params) {
        this.instance = this.instance ?? new Request();

        return this.instance.create(params);
    }

    create({api, params = null}) {
        var url = this.getUrl(api),
            fetchOptions = {method: 'POST', ...(params === null ? {} : {body: JSON.stringify(params), headers: {'Content-Type': 'application/json'}})};

        return fetch(url, fetchOptions)
            .then(async response => {
                var data = await response.json();

                if (response.ok) {
                    return data;
                }

                throw this.parseError(data);
            });
    }

    getUrl(api) {
        var [verb, resource] = api.split(' ');

        return `dispatch.php?v=${verb}&r=${resource}`;
    }

    parseError({exception = '', message}) {
        var type = exception.split('\\').pop().replace(/Exception$/, '');

        return RequestError.create({type, message});
    }
}

export default Request;